var map = {
	"./0.png": "d977",
	"./Pdf.jpg": "bb8c",
	"./css/Site.css": "f871",
	"./css/fontawesome-all.css": "424f",
	"./css/style.css": "6672",
	"./favicon.png": "99dd",
	"./images/0.png": "8d84",
	"./images/CM.jpg": "bf2c",
	"./images/Sambhajirao.jpg": "43c0",
	"./images/about_client.jpg": "6d57",
	"./images/about_us.png": "c4ee",
	"./images/about_us_SB.png": "1080",
	"./images/close.png": "d991",
	"./images/download.svg": "c482",
	"./images/favicon.png": "8925e",
	"./images/footer-logo.png": "8bef",
	"./images/footer.jpg": "9e41",
	"./images/guards.jpg": "72d4",
	"./images/guards3.jpg": "d0db",
	"./images/guards4.jpg": "ae8a",
	"./images/labour_dept_logo_new.png": "5463",
	"./images/loading.gif": "12ae",
	"./images/logo.jpg": "17be",
	"./images/logo.png": "9d64",
	"./images/logo_trans.png": "de53",
	"./images/next.png": "0f66",
	"./images/preloader.gif": "2897",
	"./images/prev.png": "b1d2",
	"./images/protfolio_bg.jpg": "628a",
	"./images/sgb.jpg": "2202",
	"./images/sgb_logo_new.png": "884f",
	"./images/slider-1.jpg": "3f01",
	"./images/slider-11.jpg": "125b",
	"./images/slider-2.jpg": "0ef1",
	"./images/slider-22.jpg": "66fe",
	"./images/slider-33.jpg": "bb5e",
	"./images/slider-44.jpg": "fd9b",
	"./images/slider-55.jpg": "bd68",
	"./images/slider-66.jpg": "2a23",
	"./images/slider-77.jpg": "61de",
	"./images/stateminister.jpg": "90ab",
	"./images/test_top1.jpg": "1465",
	"./images/top_image1.png": "aca9",
	"./images/top_image2.png": "dda8",
	"./images/top_image3.png": "6177",
	"./logo.jpg": "b640",
	"./logo.png": "cf05",
	"./logo_trans.png": "f906",
	"./pdfIcon.png": "1006",
	"./sgb_logo_new.png": "a6c3",
	"./test_top1.jpg": "e92f",
	"./top_image1.png": "0e38",
	"./top_image2.png": "1821",
	"./top_image3.png": "a8cc",
	"./webfonts/fa-brands-400.eot": "2cbf",
	"./webfonts/fa-brands-400.svg": "ba23",
	"./webfonts/fa-brands-400.ttf": "61c7",
	"./webfonts/fa-brands-400.woff": "ed55",
	"./webfonts/fa-brands-400.woff2": "a369",
	"./webfonts/fa-regular-400.eot": "0c12",
	"./webfonts/fa-regular-400.svg": "bd2c",
	"./webfonts/fa-regular-400.ttf": "7f8e",
	"./webfonts/fa-regular-400.woff": "b8fc",
	"./webfonts/fa-regular-400.woff2": "3fa2",
	"./webfonts/fa-solid-900.eot": "2a5b",
	"./webfonts/fa-solid-900.svg": "3866",
	"./webfonts/fa-solid-900.ttf": "fab2",
	"./webfonts/fa-solid-900.woff": "b8fb",
	"./webfonts/fa-solid-900.woff2": "ae64"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";